import axios from "axios";
import React, { Component } from "react";

import { Row, Col, Image } from "react-bootstrap";
import SyncLoader from "../../customLib/react-spinners/SyncLoader";

import MainData from "../../models/MainData";
import MainFunc from "../../models/MainFunc";

import logo2 from "../../images/logo.png";
import logocheckout from "../../images/undraw_Maintenance_re_59vn.svg";
import KbankHeaderBusiness from "../../components/Broker/KbankHeaderBusiness";

class Shutdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      conetntHeight: 0,
      screen: "shutdown",
      isLoading: true,
      isLoadingPage: true,
      serviceError: false,
      serviceKPayPlusError: false,
      css: "",
      logo: "",
      configDes: "",
      channelName: "",
      channel: { name: "", css: null, logo: null, font: null }
    };
  }

  componentDidMount() {
    const originalUrl = new URL(sessionStorage.getItem("homePage"));
    const cleanUrl = originalUrl.origin + originalUrl.pathname;
    window.location.href = cleanUrl;
    return;
    this.setState({
      css: sessionStorage?.getItem("customCss"),
      logo: sessionStorage?.getItem("channelLogo"),
      channelName: sessionStorage?.getItem("channelName"),
    });
    window.addEventListener("resize", () => {
      this.calContentHeight();
    });
    this.calContentHeight();

    var head = document.getElementsByTagName("head")[0];
    var link = document.createElement("link");
    link.id = "customCss";
    link.rel = "stylesheet";
    link.type = "text/css";
    link.href = this.state.css;
    link.media = "all";
    head.appendChild(link);
    if (window.location.origin.includes("localhost")) {
      MainData.serviceURL = `https://kbankonlinesale-uat.muangthai.co.th${MainData.servicePath}api`;
    } else {
      MainData.serviceURL =
        window.location.origin + `${MainData.servicePath}api`;
    }
    this.getSystemConfigData();
  }

  componentDidUpdate() {
    // this.calContentHeight();
  }

  calContentHeight = () => {
    let screenHeight = window.innerHeight;
    if (this.state.serviceError === false) {
      if (
        this.state.conetntHeight !==
        screenHeight - document.getElementById("logoSection").offsetHeight
      ) {
        this.setState({
          conetntHeight:"unset",
        });
      }
    }
  };

  getSystemConfigData = () => {
    const headers = {
      Authorization: `Bearer ${sessionStorage.getItem("bearerAuth")}`,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT,DELETE",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept,X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
    };
    const data = {
      channelCode: sessionStorage.getItem("channelName"),
    };
    axios
      .post(MainData.serviceURL + "/Sales/SystemConfig", data, {
        headers: headers,
      })
      .then((response) => {
        if (
          response.data.success &&
          response.data.data.sysStatus &&
          response.status == 299
        ) {
          this.setState({
            configDes: response.data.data.configDescriptionTh,
            isLoading: false,
          });
        } else {
          this.setState({ isLoading: false });
          window.location.href = sessionStorage.getItem("homePage");
        }
      })
      .catch((error) => {});
  };

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <div
            className="w-100 h-100 d-flex justify-content-center align-items-center"
            style={{
              zIndex: "99",
              position: "fixed",
              backgroundColor: "white",
              left: 0,
              top: 0,
            }}
          >
            <div
              className="w-100 h-100 d-flex justify-content-center align-items-center mainLoading"
              style={{ zIndex: "99", position: "fixed" }}
            >
              <Row>
                <Col xs={12} className="w-100 d-flex justify-content-center">
                  <h3 className="csMainColor">Loading</h3>
                </Col>
                <Col xs={12} className="w-100 d-flex justify-content-center">
                  <SyncLoader size={15} loading={true} />
                </Col>
              </Row>
            </div>
          </div>
        ) : null}
        <KbankHeaderBusiness
          activePage={this.state.screen}
          isLoading={this.state.isLoading}
          channelName={this.state.channelName}
          initialSalesStatus={true}
          channel={{ logo: this.state.logo }}
        >
          <Row
            style={{
              height: this.state.conetntHeight,
              maxHeight: this.state.conetntHeight,
              overflowY: "scroll",
            }}
          >
            <Col xs={12}>
              <div className="p-3 mt-3 mb-3 w-100 container">
                <Row
                  className="d-flex justify-content-center px-3 pt-3 text--shutdown"
                  dangerouslySetInnerHTML={{ __html: this.state.configDes }}
                ></Row>
                <Row className="d-flex justify-content-center pt-3">
                  {typeof window !== "undefined" && (
                    <Image
                      className="mt-2 mb-2"
                      src={logocheckout}
                      rounded
                      style={{ width: "50%" }}
                    />
                  )}
                </Row>
              </div>
            </Col>
          </Row>
        </KbankHeaderBusiness>
      </>
    );
  }
}

export default Shutdown;
